module.exports = __webpack_public_path__ + "static/homegoing-134d5cf603a654e704e7c5e19f849231.jpg";